<template>

  <div :class='["page", hasSlot("subtitleBar") ? "support-sub" : undefined]'>

    <template v-if="loading">
      <div/><div v-if="hasSlot('subtitleBar')"/>
      <div class="cover" :class="loading ? 'fadeIn' : 'fadeOut'">
          <slot name="loading-message"/>
          <smd-loading-dots/>
      </div>
    </template>

    <template v-if="!loading">
      <slot name='titleBar'/>
      <slot name='subtitleBar'/>

      <div :class='["page__content", contentStyles, !loading ? "fadeIn" : undefined]' ref='content'>
          <slot/>
      </div>

      <footer v-if="hasSlot('footer')">
        <slot name='footer'/>
      </footer>
    </template>

  </div>

</template>

<script>
  export default {
    name: 'one-column-layout',
    props: {
      loading:   {type: Boolean, default: false},
      contentStyles: Array,
      title: String
    },
    methods:{
      hasSlot(slotName){
        return !!this.$slots[slotName];
      }
    }
  }
</script>

<style lang="scss">

  @import 'scss/pogs-util';

  %full-width{
    @include space-me($key: reset, $flag: '!important');
    @include space-me($prop: margin, $key: reset);
  }

  .page{
    @include make-grid-rows(auto 1fr auto);

    width: 100%;
    height: 100%;

    &.dark,
    .dark{
      background: color(light, light-bg) !important;
    }

    &.full-width{
      & > *:not(.space-tb):not(.mdc-linear-progress){
        @extend %full-width;
      }
    }

    &.support-sub{
      grid-template-rows: auto auto 1fr auto;
    }

    &.space-l{
      & > *:not(.sub):not(.mdc-linear-progress):not(.persistent):not(.toolbar){
        @include space-me($t: base, $b: base, $r: l, $l: l, $flag: '!important');
      }

      & > header{
        min-height: 76px;
      }

      & > .persistent,
      & > .sub,
      & > .toolbar{
        @include  space-me($r: l, $l: l, $flag: '!important');
      }

      @include responsive(mobile){
        & > *:not(.sub):not(.mdc-linear-progress):not(.persistent){
          @include space-me($t: xs, $b: xs, $r: m, $l: m, $flag: '!important');
        }

        & > .persistent,
        & > .sub{
          @include  space-me($r: xs, $l: xs, $flag: '!important');
        }
      }
    }

    &.space-m{
      & > *:not(.sub):not(.mdc-linear-progress):not(.persistent){
        @include space-me(base, $flag: '!important');
      }
    }

    .full-width{
      @extend %full-width;
    }

    &.max-1000{
      max-width: 1000px;
    }

    .max-200 {
      max-width: 200px !important;
    }

    > .mdc-linear-progress {
      position: absolute;

      left: 0;
      top: 0;
      right: 0;
    }

    & > *:not(.page__content):not(.full-width):not(.mdc-linear-progress){
      @include space-me($t:s,$b:s,$r:base,$l:base);
    }

    header{
      @extend %flex-row--center-x;

      width: 100%;

      & > *:not(:last-child){
        margin-right: space(s);
      }

      &.persistent{
        @extend %border-bottom;
        @include space-me($t: s, $b: s, $flag: '!important');
        @include transition(padding 0.3s ease);

        background: white;
        min-height: 55px;
      }
    }
  }

  .page__content{
    @extend %overflow-y-auto;
    @include space-me($t:s,$b:s,$r:base,$l:base);

    position: relative;
    
    &.space-l{
      @include space-me(l);
    }

    &.space-xs{
      @include space-me(xs);
    }

    &.space-tb{
      @include space-me($prop: margin, $t: s, $b: s, $flag: '!important');
      @include space-me($r: s, $l: s, $flag: '!important');
    }

    &.space-xl{
      @include space-me(xl);
    }

    &.compact{
      @include space-me($t: base, $b: base, $key: reset);
    }
  }


  .toolbar{
    @extend  %flex-row--center-x;
    min-height: 56px;

    label + .smd-segment{
      margin-left: space(s);
    }

    & > div:not(last-child){
      margin-right: space(s);
    }
  }
</style>
